import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ContrastThreshold from './ContrastThreshold';
import ClientProvider from './client';
export default createDemo(import.meta.url, ContrastThreshold, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/palette/demos/contrast-threshold/ContrastThreshold.tsx",
    "fileName": "ContrastThreshold.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport { Stack } from '@mui/system';\n\nconst defaultContrastThresholdTheme = createTheme({});\n\nconst highContrastThresholdTheme = createTheme({\n  palette: {\n    contrastThreshold: 4.5,\n  },\n});\n\nfunction ContrastShowcase(props: { title: string }) {\n  const { title } = props;\n  const theme = useTheme();\n\n  return (\n    <Stack sx={{ gap: 1, alignItems: 'center' }}>\n      <span>\n        <b>{title}</b>\n      </span>\n      <span>{theme.palette.contrastThreshold}:1</span>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Button variant=\"contained\" color=\"warning\">\n          Warning\n        </Button>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function ContrastThreshold() {\n  return (\n    <Stack direction=\"row\" sx={{ gap: 4 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ThemeProvider theme={defaultContrastThresholdTheme}>\n        <ContrastShowcase title=\"Default contrast threshold\" />\n      </ThemeProvider>\n      <ThemeProvider theme={highContrastThresholdTheme}>\n        <ContrastShowcase title=\"Higher contrast threshold\" />\n      </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 43,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';\nimport Button from '@mui/material/Button';\nimport { Stack } from '@mui/system';\n\nconst defaultContrastThresholdTheme = createTheme({});\n\nconst highContrastThresholdTheme = createTheme({\n  palette: {\n    contrastThreshold: 4.5,\n  },\n});\n\nfunction ContrastShowcase(props: { title: string }) {\n  const { title } = props;\n  const theme = useTheme();\n\n  return (\n    <Stack sx={{ gap: 1, alignItems: 'center' }}>\n      <span>\n        <b>{title}</b>\n      </span>\n      <span>{theme.palette.contrastThreshold}:1</span>\n      <Stack direction=\"row\" sx={{ gap: 1 }}>\n        <Button variant=\"contained\" color=\"warning\">\n          Warning\n        </Button>\n      </Stack>\n    </Stack>\n  );\n}\n\nexport default function ContrastThreshold() {\n  return (\n    <Stack direction=\"row\" sx={{ gap: 4 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ThemeProvider theme={defaultContrastThresholdTheme}>\n        <ContrastShowcase title=\"Default contrast threshold\" />\n      </ThemeProvider>\n      <ThemeProvider theme={highContrastThresholdTheme}>\n        <ContrastShowcase title=\"Higher contrast threshold\" />\n      </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "defaultContrastThresholdTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ContrastShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Default contrast threshold",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "highContrastThresholdTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ContrastShowcase"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "title"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Higher contrast threshold",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 43,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Button",
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
